<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{role.id != null && role.id.length > 0 ? "Edit Role" : "Add Role"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveRole()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Name<span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="50" placeholder="Name"
                                [formControl]="name" name="name" [(ngModel)]="role.name" />
                        <mat-error *ngIf="name.invalid">Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Description<span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Description"
                                [formControl]="description" name="description" [(ngModel)]="role.description" />
                        <mat-error *ngIf="description.invalid">Description is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center pt-3 pb-4 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class="btn-black">Save </button>
            </div>
        </div>
    </div>
</form>
